// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"3a6bebc6","710":"4bf1bd0c"}[chunkId] + ".chunk.js";
};